import { render, staticRenderFns } from "./TasksSubMenuCalendar.vue?vue&type=template&id=44a8ac31&scoped=true&"
import script from "./TasksSubMenuCalendar.vue?vue&type=script&lang=js&"
export * from "./TasksSubMenuCalendar.vue?vue&type=script&lang=js&"
import style0 from "./TasksSubMenuCalendar.vue?vue&type=style&index=0&id=44a8ac31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a8ac31",
  null
  
)

export default component.exports